<template>
  <b-modal size="md" v-model="show" centered :title="'Vorgaben'"
  >
    <b-row>
      <b-col>
        <h4>Konto</h4>
        <label for="name">Maske Kontodefinition</label>
        <b-form-input id="name" type="text"
                      v-model="konto"
                      class="mb-2 text-black"
                      placeholder="z.B. Konto|Unterkonto|Gruppe"
        ></b-form-input>
        <b-form-text style="text-align: left">Bezeichungen für Kontoteile, Trennstriche | stehen für Sonderzeichen.</b-form-text>
      </b-col>
    </b-row>
    <template #modal-footer="{ok, cancel}">
      <!-- Emulate built in modal footer ok and cancel button actions -->
      <b-button size="md" variant="primary" @click="onCancel">
        Abbrechen
      </b-button>
      <b-button size="md" variant="success" @click="onSave">
        Speichern
      </b-button>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: "SettingsDialog",
  props: {
    konto_setting: {
      type: Array,
      default: () => {
        return [];
      }
    },
  },
  data() {
    return {
      show: false,
      konto: "",
    }
  },
  methods: {
    onSave() {
      this.show = false;
      this.$emit("save-settings", this.getReturnData());
    },
    onCancel() {
      this.show = false;
    },
    showDialog() {
      this.konto = this.konto_setting.join("|")
      this.show = true;
    },
    getReturnData: function () {
      console.log(this.konto)
      let splits = this.konto.split("|");
      for (let i = 0; i < splits.length; i++) {
        splits[i] = splits[i].trim();
      }
      console.log(splits)
      return {
        konto_settings: splits,
      }
    },
  }
}
</script>

<style scoped>

</style>
